export default __webpack_public_path__ + "static/media/3.25f40bd9.jpg";